import React, { useEffect, useState } from 'react';

import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import { getGASubData } from '../../api/auth';
import Header from '../../component/Header';
import NavbarGA from '../../component/NavBarGA';
import Spinner from '../../component/Spinner';

function MainSub() {

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const navigate = useNavigate();

    const [isShow, setIsShow] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [date, setDate] = useState('');
    const [subData, setSubData] = useState([]);
    const [subLineData, setSubLineData] = useState([]);

    useEffect(() => {
        if (!activeAccount) {
            navigate("/mesga");
        }
    }, [activeAccount]);

    useEffect(() => {
        (async () => {
            try {
                setIsShow(true);
                const result = await getGASubData();
                console.log('result', result);
                if (result.ok === true) {
                    setDate(result.date);
                    setSubData(result.data);
                    setSubLineData(result?.data?.output?.subcnt?.filter(v => v.LINE.substring(0, 1) === "B"));
                } else {
                    alert("API CALL FAIL");
                }
            } catch (error) {
                console.log('error', error);
                alert(error.message);
            } finally {
                setIsShow(false);
            }
        })();
    }, [refresh]);

    return (
        <>
            <Spinner isShow={isShow} />
            <Header setRefresh={setRefresh} />
            <NavbarGA />
            <div className='p-1 text-md'>
                {
                    subData?.output?.subcnt !== null && (
                        <div className="relative overflow-x-auto mt-3">
                            <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                                <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                                    <tr>
                                        <th scope="col" className="py-1">
                                            LOC
                                        </th>
                                        <th scope="col" className="py-1">
                                            BUF
                                        </th>
                                        <th scope="col" className="py-1">
                                            TGT
                                        </th>
                                        <th scope="col" className="py-1">
                                            LOC
                                        </th>
                                        <th scope="col" className="py-1">
                                            BUF
                                        </th>
                                        <th scope="col" className="py-1">
                                            TGT
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="text-black">
                                    {subLineData?.map((v, i) => {
                                        return i % 2 === 0 ? (
                                            <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b border-t`}>
                                                <th className="py-1 bg-slate-300 text-left">
                                                    <span>&nbsp;&nbsp;&nbsp;</span>
                                                    <span className="font-extrabold" style={{
                                                        color:
                                                            parseInt(subLineData[i].BUFFER) <= parseInt(subLineData[i].KMINVAL) ? 'red'
                                                                : parseInt(subLineData[i].BUFFER) < parseInt(subLineData[i].KMAXVAL) ? 'KMAXVAL'
                                                                    : 'green'
                                                    }}>
                                                        O
                                                    </span>
                                                    <span> </span>
                                                    {subLineData[i].LINE}
                                                </th>
                                                <th className="py-1">
                                                    {subLineData[i].BUFFER}
                                                </th>
                                                <th className="py-1">
                                                    {subLineData[i].TARGET}
                                                </th>
                                                {
                                                    subLineData[i + 1] !== undefined ? (
                                                        <>
                                                            <th className="py-1 bg-slate-300 text-left">
                                                                <span>&nbsp;&nbsp;&nbsp;</span>
                                                                <span className="font-extrabold" style={{
                                                                    color:
                                                                        parseInt(subLineData[i + 1].BUFFER) <= parseInt(subLineData[i + 1].KMINVAL) ? 'red'
                                                                            : parseInt(subLineData[i + 1].BUFFER) < parseInt(subLineData[i + 1].KMAXVAL) ? 'KMAXVAL'
                                                                                : 'green'
                                                                }}>
                                                                    O
                                                                </span>
                                                                <span> </span>
                                                                {subLineData[i + 1].LINE}
                                                            </th>
                                                            <th className="py-1">
                                                                {subLineData[i + 1].BUFFER}
                                                            </th>
                                                            <th className="py-1">
                                                                {subLineData[i + 1].TARGET}
                                                            </th>
                                                        </>
                                                    ) : null
                                                }
                                            </tr>
                                        ) : null
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )
                }
                {
                    subData?.output?.linestop?.map((v, i) => {
                        return (
                            <div key={i} className={`${i === 0 ? 'mt-3' : ''} text-lg`}>
                                {v.LINESTOP}
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}

export default MainSub;
